var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAppDownloadOsWindowsWhite = function SvgAppDownloadOsWindowsWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m0 6.393 18.396-2.505.008 17.745-18.387.104zm18.388 17.284.014 17.76L.014 38.91V23.558l18.374.12zm2.23-20.117L45.01 0v21.407l-24.392.193zm24.397 20.284-.005 21.31-24.392-3.442-.035-17.908z"
  })));
};
export default SvgAppDownloadOsWindowsWhite;